import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import InvoiceHistoryListRow from './InvoiceHistoryListRow';

interface ITotal {
    currency: any;
    paidSum: number;
    toPaySum: number;
    creditedSum: number;
    creditedPaidSum: number;
    restSum: number;
}

interface IInvoiceHistoryListProps {
    items: any[];
    totals: ITotal[];
    showInvoice: (invoiceId: any) => void;
    creditInvoice: (invoiceId: any) => void;
    createPayment: (invoiceId: any) => void;
    viewPayments: (invoiceId: any) => void;
    downloadInvoice: (invoiceId: any) => void;
    canViewPayments: boolean;
    canCreatePayments: boolean;
    canCreditInvoice: boolean;
}

const InvoiceHistoryList = (props: IInvoiceHistoryListProps) => {
    return (
        <Table className="invoice-history-table" hover responsive>
            <thead>
                <tr>
                    <th>{Translate('invoice-history/list/header/invoice-number')}</th>
                    <th>{Translate('invoice-history/list/header/invoice-date')}</th>
                    <th>{Translate('invoice-history/list/header/due-date')}</th>
                    <th>{Translate('invoice-history/list/header/paid-date')}</th>
                    <th>{Translate('invoice-history/list/header/status')}</th>
                    <th>{Translate('invoice-history/list/header/customer')}</th>
                    <th>{Translate('invoice-history/list/header/sum-incl-vat')}</th>
                    <th>{Translate('invoice-history/list/header/paid-amount')}</th>
                    <th>{Translate('invoice-history/list/header/credited-amount')}</th>
                    <th>{Translate('invoice-history/list/header/credited-paid-amount')}</th>
                    <th>{Translate('invoice-history/list/header/rest-amount')}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {props.items.map((i: any, index: number) => (
                    <InvoiceHistoryListRow
                        key={index}
                        invoiceNumber={i.invoiceNr}
                        invoiceDate={i.invoiceDate}
                        dueDate={i.dueDate}
                        paidDate={i.paidDate}
                        status={i.status}
                        customer={i.customer}
                        sum={i.sumInclVAT}
                        paid={i.paid}
                        credited={i.credited}
                        creditedPaid={i.creditedPaid}
                        rest={i.rest}
                        type={i.type}
                        canViewPayments={props.canViewPayments}
                        canCreatePayments={props.canCreatePayments}
                        canCreditInvoice={props.canCreditInvoice}
                        showInvoice={() => props.showInvoice(i.id)}
                        creditInvoice={() => props.creditInvoice(i.id)}
                        createPayment={() => props.createPayment(i.id)}
                        viewPayments={() => props.viewPayments(i.id)}
                        downloadInvoice={() => props.downloadInvoice(i.id)}
                        invoiceCurrency={i.invoiceCurrency}
                        pastDueDate={i.pastDueDate}
                        rowClass={
                            i.type === 2
                                ? 'invoice-row-credit'
                                : i.pastDueDate
                                ? 'invoice-row-past-due-date'
                                : ''
                        }
                    />
                ))}

                {props.totals.map((total: ITotal, i: number) => (
                    <tr
                        key={`total-${i}`}
                        className={`${i === 0 ? 'invoice-totals-separator' : ''}`}
                    >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <strong>
                                {i === 0 ? Translate('economy/invoices/history/totals') : ''}
                            </strong>
                        </td>
                        <td>
                            <strong>{total.currency.displayName}</strong>
                        </td>
                        <td>
                            <strong>
                                {total.currency.prefix}
                                {total.toPaySum}
                                {total.currency.suffix}
                            </strong>
                        </td>
                        <td>
                            <strong>
                                {total.currency.prefix}
                                {total.paidSum}
                                {total.currency.suffix}
                            </strong>
                        </td>
                        <td>
                            <strong>
                                {total.currency.prefix}
                                {total.creditedSum}
                                {total.currency.suffix}
                            </strong>
                        </td>
                        <td>
                            <strong>
                                {total.currency.prefix}
                                {total.creditedPaidSum}
                                {total.currency.suffix}
                            </strong>
                        </td>
                        <td>
                            <strong>
                                {total.currency.prefix}
                                {total.restSum}
                                {total.currency.suffix}
                            </strong>
                        </td>
                        <td></td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default InvoiceHistoryList;
